
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/uiAnimations/components/leftBarPanelsAnimation.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_16nqv_1","opened":"_opened_16nqv_1"};